export function getLoginPathSegment(): string {
  return (process.env.REACT_APP_LOGIN_PATH || '').replace(/^\/+|\/+$/g, '');
}

export function isShowMaintenance(): boolean {
  return process.env.REACT_APP_SHOW_MAINTENANCE === 'true';
}

/** Secret login URL used while maintenance is on: `/{REACT_APP_LOGIN_PATH}/login`. */
export function getMaintenanceLoginPath(): string {
  const prefix = getLoginPathSegment();
  return prefix ? `/${prefix}/login` : '/';
}

export function isPublicAuthPath(pathname?: string): boolean {
  const path = (pathname || '').toLowerCase();
  if (path === '/' || path === '') return true;
  if (path === '/meet-scope') return true;
  if (isShowMaintenance()) {
    return path === getMaintenanceLoginPath().toLowerCase();
  }
  return false;
}
